
export class SpielPartie {
    constructor(freieSpieler, isCup) {
        this.heim = JSON.parse(JSON.stringify(this.getSpieler(freieSpieler, isCup)));
        this.gast = JSON.parse(JSON.stringify(this.getSpieler(freieSpieler, isCup)));
    }

    getSpieler(freieSpieler, isCup){
        const spieler = {
            spieler: {
                // ACHTUNG: auch in spielBerichtEditMaLTeam aktualisieren
                id: '',
                passNr: '',
                name: '',
                nationalitaet: '',
                akHJ: '',
                akJahr: '',
            },
            input: {
                d1: 0,
                d2: 0,
                d3: 0,
                d4: 0,
            },
            oeR: false,
            bR: false,
            bahn: 0,
            fehlwuerfe: 0,
            sp1: 0,
            sp2: 0,
            sp3: 0,
            sp4: 0,
            kegel: 0,
            sp: 0,
            mp: 0
        };
        if ( isCup ) {
            spieler.inputAr = {
                ar1: 0,
                ar2: 0,
                ar3: 0,
                ar4: 0,
            }
            spieler.ar = 0
        }

        if ( freieSpieler ) {
            spieler.spieler.frei = false;
            spieler.spieler.hatPass = false;
        }
        return spieler;
    }
}